import axios from './axios.js'

export const getPluginRequest = (username) => axios.get(`/plugin/${username}`)